import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Constants } from "../Common/Constants";
import { types } from "../../Redux/Actions/types";
import TextField from "../Common/Fields/TextField";
import ButtonCustom from "../Common/Fields/ButtonCustom";
import {
  exerciseGoalInsert,
  exerciseGoalList,
  exerciseGoalUpdate,
} from "../../Redux/Actions";
import usePermissions from "../Common/Functions/usePermissions";

const ExerciseGoalForm = () => {
  const dispatch = useDispatch();
  const { exerciseGoalSingle } = useSelector((state) => state.ExerciseGoal);
  // Permissions
  const addPermission = usePermissions(Constants.permission.EXER_GOAL_ADD);
  const editPermission = usePermissions(Constants.permission.EXER_GOAL_EDIT);

  // Initial values to Exercise Goal form
  const [initialValues, setInitialValues] = useState({
    name: "",
  });

  // Validations for Exercise Goal form
  const validationSchema = Yup.object().shape({
    name: Yup.string().required(Constants.required),
  });

  useEffect(() => {
    // Set initial values to pre fill Exercise Goal form
    if (exerciseGoalSingle?._id) {
      const editValue = {};
      for (const [key] of Object.entries(initialValues)) {
        if (exerciseGoalSingle[key]) {
          editValue[key] = exerciseGoalSingle[key];
        }
        setInitialValues(editValue);
      }
    }
  }, [exerciseGoalSingle]);

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        // Add or update exercise Goal API
        let submitFunc = exerciseGoalInsert(values);
        if (exerciseGoalSingle._id) {
          values.id = exerciseGoalSingle._id;
          submitFunc = exerciseGoalUpdate(values);
        }
        dispatch(submitFunc).then((response) => {
          if (response.error) {
            dispatch({
              type: types.ERROR_ALERT_VISIBLE,
              payload: response.error,
            });
          } else {
            dispatch({
              type: types.SUCCESS_ALERT_VISIBLE,
              payload: response.message,
            });
            dispatch({ type: types.EXERCISE_GOAL_SINGLE, payload: "" });
            dispatch({ type: types.EXERCISE_GOAL_FORM_MODEL, payload: "" });
          }
          dispatch(exerciseGoalList());
        });
      }}
    >
      {({ errors, touched }) => (
        <Form className="row">
          <div className="col-md-12 mb-2">
            <TextField
              type="text"
              name="name"
              className="form-control"
              errors={touched?.name ? errors?.name : undefined}
              touched={touched?.name}
              label={Constants.name}
            />
          </div>
          {((addPermission && !exerciseGoalSingle?._id) ||
            (editPermission && exerciseGoalSingle?._id)) && (
            <ButtonCustom label={Constants.submit} type="submit" />
          )}
        </Form>
      )}
    </Formik>
  );
};

export default ExerciseGoalForm;
